export default __webpack_public_path__ + "static/media/BE01.ad65cd5c.mp3";